import React from 'react';
export const Activity = (props) => {
    return <>{props.children}</>;
};
